import { CssBaseline } from '@mui/material'
import React, { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'
import { DialogProvider, Loader } from '../Components/Shared'
import MUIDrawer from '../Components/Shared/MUI-Drawer'
import { PAGE_NAME } from '../Constants'
import { DrawerData as initialDrawerData } from '../Constants/Constant/SidebarConstent'
import { BLITZ_MODULE } from '../Constants/Roles'
import { useAppSelector } from '../Store/Hooks'
import ConfigLoader from './ConfigLoader'

const CommonLayoutContent = () => {
  return (
    <DialogProvider>
      <Suspense fallback={<Loader />}>
        <div className='root'>
          <Loader />
          <Outlet />
        </div>
      </Suspense>
    </DialogProvider>
  )
}

interface DefaultLayoutProps {
  isPlainLayout?: boolean
}

const DefaultLayout: React.FC<DefaultLayoutProps> = ({ isPlainLayout }) => {
  const { contentCategories, auditTrails, buildConfig, managePolicyConfig } = useAppSelector(
    (state) => state.appConfig,
  )
  const { granularControlValidationEnable, languageControlValidationEnable } =
    managePolicyConfig || {}

  const [drawerData, setDrawerData] = useState(initialDrawerData)

  useEffect(() => {
    const updateDrawerData = () => {
      const updatedData: any = initialDrawerData.map((page) => {
        let pageCopy: any = { ...page }
        if (page.lable === PAGE_NAME.ManageContentLabel) {
          pageCopy = {
            ...page,
            child:
              Array.isArray(contentCategories) && contentCategories.length > 0
                ? [
                    ...contentCategories.map((category: any) => ({
                      lable: category.value,
                      id: category._id,
                      path: `manage-content/${category.key.toLowerCase().replace(/ /g, '-')}`,
                      role: BLITZ_MODULE.MANAGE_CONTENT.key,
                    })),
                  ]
                : [...page.child],
          }
        }
        if (page.lable === PAGE_NAME.AuditLogsLabel) {
          pageCopy = {
            ...page,
            child:
              Array.isArray(auditTrails) && auditTrails.length > 0
                ? [
                    ...auditTrails.map((auditLogCategory: any) => ({
                      lable: auditLogCategory.value,
                      id: auditLogCategory._id,
                      path: `audit-logs/${auditLogCategory.key.toLowerCase().replace(/ /g, '-')}`,
                      role: BLITZ_MODULE.AUDIT_TRAILS.key,
                    })),
                  ]
                : [...page.child],
          }
        }
        if (page.lable === PAGE_NAME.ManagePoliciesLabel) {
          pageCopy.child = pageCopy.child.filter((item: any) => {
            if (item.lable === PAGE_NAME.EntitlementControlPolicyLable) {
              return granularControlValidationEnable
            }
            if (item.lable === PAGE_NAME.LanguageControlPolicyLabel) {
              return languageControlValidationEnable
            }
            return true
          })
        }
        if (pageCopy?.child?.length) {
          pageCopy.path = pageCopy.child[0].path
        }
        return pageCopy
      })
      setDrawerData(updatedData)
    }

    if (contentCategories?.length) {
      updateDrawerData()
    }
  }, [contentCategories, auditTrails, granularControlValidationEnable])

  return (
    <ConfigLoader>
      {isPlainLayout ? (
        <>
          <CssBaseline />
          <MUIDrawer
            drawerData={drawerData}
            buildConfig={buildConfig}
            isPlainLayout={isPlainLayout}
          >
            <CommonLayoutContent />
          </MUIDrawer>
        </>
      ) : (
        <MUIDrawer drawerData={drawerData} buildConfig={buildConfig}>
          <CommonLayoutContent />
        </MUIDrawer>
      )}
    </ConfigLoader>
  )
}

export default DefaultLayout
